import { getIsFeatureEnabled } from '@/utils/app-config.js';
import useAvailableFromAssets from './use-available-from-assets.js';

type IsSwapSupportedByAsset = {
  value: boolean;
  loading: boolean;
};

function useIsSwapSupportedByAsset(assetName: string): IsSwapSupportedByAsset {
  const swapsEnabled = getIsFeatureEnabled('swaps');

  const { value: availableFromAssets, loading } = useAvailableFromAssets();

  return {
    value:
      swapsEnabled &&
      availableFromAssets.some((asset) => asset.name === assetName),
    loading,
  };
}

export default useIsSwapSupportedByAsset;
